<!--
  - SPDX-FileCopyrightText: 2024 Nextcloud GmbH and Nextcloud contributors
  - SPDX-License-Identifier: AGPL-3.0-or-later
-->
<template>
	<RowFormWrapper :title="column.title" :mandatory="isMandatory(column)" :description="column.description" :width="2">
		<NcSelect v-model="localValue" style="width: 100%;" :loading="loading" :options="options"
			:placeholder="getPlaceholder()" :searchable="true" :get-option-key="(option) => option.key"
			label="displayName" :aria-label-combobox="getPlaceholder()"
			:user-select="true"
			:clearable="!column.mandatory"
			:disabled="column.viewColumnInformation?.readonly"
			:close-on-select="false"
			:multiple="column.usergroupMultipleItems"
			data-cy="usergroupRowSelect"
			@search="asyncFind" @update:model-value="addItem">
			<template #noResult>
				{{ noResultText }}
			</template>
		</NcSelect>
	</RowFormWrapper>
</template>

<script>
import { NcSelect } from '@nextcloud/vue'
import RowFormWrapper from './RowFormWrapper.vue'
import searchUserGroup from '../../../../mixins/searchUserGroup.js'
import ShareTypes from '../../../../mixins/shareTypesMixin.js'
import rowHelper from '../../../../components/ncTable/mixins/rowHelper.js'
export default {
	components: {
		RowFormWrapper,
		NcSelect,
	},
	mixins: [ShareTypes, searchUserGroup, rowHelper],
	props: {
		column: {
			type: Object,
			default: null,
		},
		value: {
			type: Array,
			default: () => ([]),
		},
	},
	emits: [
		'update:value',
	],
	data() {
		return {
			selectUsers: this.column.usergroupSelectUsers,
			selectGroups: this.column.usergroupSelectGroups,
		}
	},
	computed: {
		localValue: {
			get() {
				let value = this.value
				if (!value || (Array.isArray(value) && value.length === 0)) {
					value = this.column.usergroupDefault || []
				}
				return (Array.isArray(value) ? value : []).map(item => ({
					...(item ?? {}),
					// Adding a unique key such that removing items works correctly
					key: this.getKeyPrefix(item?.type) + (item?.id ?? ''),
				}))
			},
			set(v) {
				this.$emit('update:value', Array.isArray(v) ? v : [v])
			},
		},
	},
	created() {
		// Update the circles-related data once the component is created
		// Doing this in data() doesn't work due to timing issues,
		// since the data() function runs before the capabilities are fully initialized
		this.selectCircles = this.isCirclesEnabled ? this.column.usergroupSelectTeams : false

		if (!this.value || (Array.isArray(this.value) && this.value.length === 0)) {
			if (this.localValue.length > 0) {
				this.$emit('update:value', this.localValue)
			}
		}
	},
	methods: {
		addItem(selectedItem) {
			if (selectedItem) {
				this.localValue = selectedItem
			} else {
				this.localValue = []
			}
		},

		getKeyPrefix(type) {
			switch (type) {
			case 0: return 'users-'
			case 1: return 'groups-'
			case 2: return 'circles-'
			default: return 'unknown-'
			}
		},

		filterOutUnwantedItems(list) {
			return list
		},

		formatResult(autocompleteResult) {
			return {
				id: autocompleteResult.id,
				type: this.getType(autocompleteResult.source),
				key: autocompleteResult.source + '-' + autocompleteResult.id,
				displayName: autocompleteResult.label,
			}
		},

	},
}
</script>
